// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/gift_shop/gift_shop.proto" (package "mlmbox.client.gift_shop", syntax proto3)
// tslint:disable
import { GiftShop_Info } from "../../types/gift_shop.ts";
import { GiftShop_Card_Id } from "../../types/gift_shop.ts";
import { GiftShop_State } from "../../types/gift_shop.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message mlmbox.client.gift_shop.CreateRequest
 */
export interface CreateRequest {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: string price_value = 3;
     */
    priceValue: string;
    /**
     * @generated from protobuf field: bytes image = 4;
     */
    image: Uint8Array;
}
/**
 * @generated from protobuf message mlmbox.client.gift_shop.CardUpdateInfoRequest
 */
export interface CardUpdateInfoRequest {
    /**
     * @generated from protobuf field: uint32 card_id = 1;
     */
    cardId: number;
    /**
     * @generated from protobuf field: string title = 2;
     */
    title: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string price_value = 4;
     */
    priceValue: string;
    /**
     * @generated from protobuf field: bytes image = 5;
     */
    image: Uint8Array;
}
/**
 * @generated from protobuf message mlmbox.client.gift_shop.WithdrawalRequest
 */
export interface WithdrawalRequest {
    /**
     * @generated from protobuf field: uint32 card_id = 1;
     */
    cardId: number;
    /**
     * @generated from protobuf field: string address = 2;
     */
    address: string;
}
/**
 * @generated from protobuf message mlmbox.client.gift_shop.ReviewRequest
 */
export interface ReviewRequest {
    /**
     * @generated from protobuf field: uint32 card_id = 1;
     */
    cardId: number;
    /**
     * @generated from protobuf field: string video_url = 2;
     */
    videoUrl: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateRequest$Type extends MessageType<CreateRequest> {
    constructor() {
        super("mlmbox.client.gift_shop.CreateRequest", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "price_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "image", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<CreateRequest>): CreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.title = "";
        message.description = "";
        message.priceValue = "";
        message.image = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<CreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateRequest): CreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string title */ 1:
                    message.title = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string price_value */ 3:
                    message.priceValue = reader.string();
                    break;
                case /* bytes image */ 4:
                    message.image = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string title = 1; */
        if (message.title !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.title);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string price_value = 3; */
        if (message.priceValue !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.priceValue);
        /* bytes image = 4; */
        if (message.image.length)
            writer.tag(4, WireType.LengthDelimited).bytes(message.image);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.gift_shop.CreateRequest
 */
export const CreateRequest = new CreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CardUpdateInfoRequest$Type extends MessageType<CardUpdateInfoRequest> {
    constructor() {
        super("mlmbox.client.gift_shop.CardUpdateInfoRequest", [
            { no: 1, name: "card_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "price_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "image", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<CardUpdateInfoRequest>): CardUpdateInfoRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cardId = 0;
        message.title = "";
        message.description = "";
        message.priceValue = "";
        message.image = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<CardUpdateInfoRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CardUpdateInfoRequest): CardUpdateInfoRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 card_id */ 1:
                    message.cardId = reader.uint32();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string price_value */ 4:
                    message.priceValue = reader.string();
                    break;
                case /* bytes image */ 5:
                    message.image = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CardUpdateInfoRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 card_id = 1; */
        if (message.cardId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.cardId);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string price_value = 4; */
        if (message.priceValue !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.priceValue);
        /* bytes image = 5; */
        if (message.image.length)
            writer.tag(5, WireType.LengthDelimited).bytes(message.image);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.gift_shop.CardUpdateInfoRequest
 */
export const CardUpdateInfoRequest = new CardUpdateInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WithdrawalRequest$Type extends MessageType<WithdrawalRequest> {
    constructor() {
        super("mlmbox.client.gift_shop.WithdrawalRequest", [
            { no: 1, name: "card_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WithdrawalRequest>): WithdrawalRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cardId = 0;
        message.address = "";
        if (value !== undefined)
            reflectionMergePartial<WithdrawalRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WithdrawalRequest): WithdrawalRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 card_id */ 1:
                    message.cardId = reader.uint32();
                    break;
                case /* string address */ 2:
                    message.address = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WithdrawalRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 card_id = 1; */
        if (message.cardId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.cardId);
        /* string address = 2; */
        if (message.address !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.address);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.gift_shop.WithdrawalRequest
 */
export const WithdrawalRequest = new WithdrawalRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReviewRequest$Type extends MessageType<ReviewRequest> {
    constructor() {
        super("mlmbox.client.gift_shop.ReviewRequest", [
            { no: 1, name: "card_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "video_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReviewRequest>): ReviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cardId = 0;
        message.videoUrl = "";
        if (value !== undefined)
            reflectionMergePartial<ReviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReviewRequest): ReviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 card_id */ 1:
                    message.cardId = reader.uint32();
                    break;
                case /* string video_url */ 2:
                    message.videoUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 card_id = 1; */
        if (message.cardId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.cardId);
        /* string video_url = 2; */
        if (message.videoUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.videoUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.gift_shop.ReviewRequest
 */
export const ReviewRequest = new ReviewRequest$Type();
/**
 * @generated ServiceType for protobuf service mlmbox.client.gift_shop.GiftShop
 */
export const GiftShop = new ServiceType("mlmbox.client.gift_shop.GiftShop", [
    { name: "Info", options: {}, I: Empty, O: GiftShop_State },
    { name: "CardGet", options: {}, I: GiftShop_Card_Id, O: GiftShop_Info },
    { name: "CardCreate", options: {}, I: CreateRequest, O: GiftShop_Info },
    { name: "CardUpdate", options: {}, I: CardUpdateInfoRequest, O: GiftShop_Info },
    { name: "CardRemove", options: {}, I: GiftShop_Card_Id, O: Empty },
    { name: "CardBuy", options: {}, I: GiftShop_Card_Id, O: GiftShop_Info },
    { name: "Withdrawal", options: {}, I: WithdrawalRequest, O: GiftShop_Info },
    { name: "Review", options: {}, I: ReviewRequest, O: GiftShop_Info }
]);
